export default __webpack_public_path__ + "static/media/21-FierySunset.e064e86f.jpeg";